import React, { useEffect, useRef, useState } from "react";
import { LexRuntimeV2 } from "@aws-sdk/client-lex-runtime-v2";
import * as AWS from "aws-sdk";
import "../src/chat.css";
import { v4 as uuidv4 } from "uuid";
import emailjs from "emailjs-com";
import ChatBoxThankyouScreen from "./ChatBoxThankyouScreen";
const lexruntime = new LexRuntimeV2({
  region: "us-east-1",
  credentials: new AWS.Credentials({
    accessKeyId: "AKIAU6GDXBA3KWYRKTAM",
    secretAccessKey: "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",
  }),
});

const Chatbot = () => {
  let myPlugin = "";
  const [inputText, setInputText] = useState("");
  const [messages, setMessages] = useState([]);
  const [isChatboxOpen, setIsChatboxOpen] = useState(false);
  const [isThanKyouScreenOpen, setIsThanKyouScreenOpen] = useState(false);
  const [isWelcomeChatboxOpen, setIsWelcomeChatboxOpen] = useState(false);
  const messagesEndRef = useRef(null);
  const [sessionId, setSessionId] = useState(uuidv4());
  const [clientDetails, setClientDetails] = useState({
    firstName: "",
    email: "",
    message: "",
  });
  const [loader, setLoader] = useState(true);
  const [timerId, setTimerId] = useState(null);
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  const [charCount, setCharCount] = useState(0);
  const [charLimitExceeded, setCharLimitExceeded] = useState(false);

  const inputRef = useRef(null);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, [isChatboxOpen]);

  useEffect(() => {
    scrollToBottom();
    if (messages.length) {
      setLoader(false);
    }
  }, [messages]);
  console.log({ messages });

  useEffect(() => {
    if (!messages.length && isWelcomeChatboxOpen) {
      const lexparams = {
        botId: "T3SFAN3T0I",
        botAliasId: "TSTALIASID",
        localeId: "en_US",
        sessionId: sessionId,
        text: "hi",
      };
      lexruntime.recognizeText(lexparams).then((data) => {
        const botMessages = data.messages.map((message) => ({
          text: message.content,
          sender: "bot",
        }));
        setMessages([...botMessages]);
      });
    }
  }, [isWelcomeChatboxOpen]);

  useEffect(() => {
    emailjs.init("cJ2y5F8zlPl59v2ZB");
  }, []);

  const sendEmail = (firstName, email, message) => {
    const templateParams = {
      from_name: "Chatbot",
      to_name: "CCS",
      first_name: firstName,
      email: email,
      message: message || "No message provided",
      reply_to: "apps.ccs@gmail.com",
    };

    emailjs.send("service_xxb114q", "template_7skgz0c", templateParams).then(
      (response) => {
        setIsChatboxOpen(false);
        setMessages([]);
        setSessionId(uuidv4());
        clearTimeout(timerId);
        // setIsThanKyouScreenOpen(true);
        console.log("SUCCESS!", response.status, response.text);
      },
      (err) => {
        console.log("FAILED...", err);
      }
    );
  };
  useEffect(() => {
    console.log(messages);
  }, [messages]);

  const sendMessage = async () => {
    if (!inputText.trim() || charLimitExceeded) return;

    const newMessages = [...messages, { text: inputText, sender: "user" }];
    setMessages(newMessages);
    setInputText("");
    setCharCount(0);
    setCharLimitExceeded(false);

    const lexparams = {
      botId: "T3SFAN3T0I",
      botAliasId: "TSTALIASID",
      localeId: "en_US",
      sessionId: sessionId,
      text: inputText,
    };

    try {
      const data = await lexruntime.recognizeText(lexparams);

      const botMessages = data.messages.map((message) => ({
        text: message.content,
        sender: "bot",
      }));
      setMessages([...newMessages, ...botMessages]);

      const slots = data.interpretations[0].intent.slots;
      const firstName = slots.Name?.value?.interpretedValue;
      const email = slots.Email?.value?.interpretedValue;
      const message = slots.Message?.value?.interpretedValue;
      setClientDetails({ firstName, email, message });
      console.log({ clientDetails, slots });

      if (firstName && email) {
        if (timerId) clearTimeout(timerId);

        if (firstName && email && message) {
          sendEmail(firstName, email, message);
        } else {
          const newTimerId = setTimeout(() => {
            sendEmail(firstName, email, message || "No message provided");
          }, 2700000);
          setTimerId(newTimerId);
        }
      }
    } catch (err) {
      console.log(err, err.stack);
    }
  };

  useEffect(() => {
    if (clientDetails.message) {
      // setIsChatboxOpen(false);
      setIsChatboxOpen(false);
      setIsThanKyouScreenOpen(true);
    }
  }, [clientDetails]);

  const toggleChatbox = () => {
    setIsChatboxOpen(!isChatboxOpen);
    setIsWelcomeChatboxOpen(false);
  };
  const handleKeyPress = (event) => {
    if (timerId) clearTimeout(timerId);
    if (event.key === "Enter" && !charLimitExceeded) {
      sendMessage();
    }
  };
  const handleInputChange = (e) => {
    const text = e.target.value;
    setInputText(text);
    setCharCount(text.length);
    setCharLimitExceeded(text.length > 1000);
  };

  return (
    <>
      {isThanKyouScreenOpen && (
        <ChatBoxThankyouScreen
          setIsThanKyouScreenOpen={setIsThanKyouScreenOpen}
        />
      )}
      {!isWelcomeChatboxOpen && !isChatboxOpen && !isThanKyouScreenOpen && (
        <button className="chatbot-button">
          <i className="chat-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="28"
              height="25"
              viewBox="0 0 28 25"
              fill="none"
            >
              <path
                d="M5.94207 18.6119C5.23009 18.5855 4.54534 18.586 3.86604 18.5258C3.32685 18.4769 2.78024 18.4064 2.26135 18.2591C1.03346 17.9112 0.386341 17.0271 0.202156 15.82C0.0855649 15.0628 0.0231891 14.2984 0.0154957 13.5325C-0.00595948 10.7028 -0.00513489 7.87337 0.0179707 5.04427C0.0209985 4.22165 0.0983817 3.40094 0.249193 2.59192C0.519033 1.19743 1.40628 0.377376 2.82827 0.197805C3.81777 0.0745443 4.81403 0.0117953 5.81136 0.00991619C11.4386 -0.00541504 17.0664 -0.00296887 22.6949 0.0172553C23.5028 0.0178286 24.3088 0.093844 25.1022 0.244288C26.5257 0.520739 27.3213 1.37358 27.5317 2.78862C27.6449 3.52973 27.7062 4.27769 27.7149 5.02714C27.7357 7.86505 27.7402 10.703 27.7149 13.5409C27.711 14.3631 27.6323 15.1834 27.4797 15.9917C27.205 17.4038 26.3311 18.2175 24.8843 18.3952C23.8035 18.5191 22.7165 18.5825 21.6284 18.585C19.038 18.6109 16.447 18.5977 13.8551 18.5889C13.455 18.5889 13.1475 18.7205 12.8648 18.9994C11.1329 20.7227 9.39569 22.4406 7.6532 24.1532C7.34474 24.457 6.97538 24.549 6.56394 24.3949C6.18319 24.2525 5.94256 23.8865 5.94157 23.452C5.93926 21.9355 5.93926 20.4187 5.94157 18.9016L5.94207 18.6119ZM7.92255 21.1161C8.03444 21.0104 8.09336 20.9566 8.1503 20.9003C9.27075 19.7945 10.3947 18.6926 11.5087 17.581C12.1608 16.9302 12.9386 16.6293 13.8645 16.6327C16.5876 16.6425 19.3108 16.6494 22.0339 16.6259C22.9138 16.6185 23.7931 16.528 24.6704 16.4492C25.1854 16.4003 25.4998 16.093 25.5587 15.5827C25.6359 14.9119 25.731 14.2381 25.7354 13.5648C25.7546 10.7198 25.7546 7.87451 25.7354 5.0291C25.7305 4.348 25.6364 3.66592 25.5542 2.98727C25.4968 2.49798 25.1883 2.20147 24.6962 2.14813C23.9599 2.06838 23.2202 1.97199 22.4815 1.97003C16.9692 1.95372 11.4582 1.95225 5.94851 1.96563C4.97857 1.96856 4.00814 2.06348 3.04067 2.14862C2.53417 2.19217 2.23214 2.51021 2.1752 3.00782C2.09797 3.68696 2.0034 4.36904 1.99845 5.05014C1.97864 7.86325 1.97864 10.676 1.99845 13.4885C2.0034 14.1862 2.09747 14.8845 2.17422 15.5798C2.23115 16.0901 2.54654 16.3949 3.06097 16.4492C3.78929 16.526 4.52058 16.5784 5.25187 16.6293C5.57222 16.6513 5.8985 16.6146 6.21538 16.6572C7.20066 16.7893 7.91611 17.6108 7.92453 18.6002C7.92799 19.4139 7.92255 20.2276 7.92255 21.1161Z"
                fill="white"
              />
              <path
                d="M12.8751 9.27597C12.8812 8.88836 13.0419 8.51881 13.3223 8.24768C13.6027 7.97656 13.98 7.82578 14.3723 7.82815C14.5689 7.82967 14.7632 7.86973 14.944 7.94602C15.1248 8.02231 15.2885 8.13331 15.4255 8.27258C15.5626 8.41186 15.6703 8.57663 15.7425 8.75736C15.8146 8.93808 15.8497 9.13116 15.8458 9.32539C15.8362 9.71293 15.6723 10.0811 15.3898 10.35C15.1073 10.619 14.7289 10.767 14.3367 10.762C13.9441 10.7544 13.5704 10.5941 13.2968 10.3158C13.0231 10.0376 12.8716 9.66396 12.8751 9.27597Z"
                fill="white"
              />
              <path
                d="M7.43531 7.82815C7.63125 7.82923 7.82504 7.86862 8.00551 7.94403C8.18599 8.01945 8.34958 8.12941 8.48686 8.26758C8.62415 8.40575 8.73241 8.5694 8.80542 8.7491C8.87843 8.9288 8.91473 9.121 8.91225 9.31463C8.90677 9.70138 8.74705 10.0704 8.4678 10.3414C8.18855 10.6124 7.81234 10.7635 7.42095 10.762C7.22475 10.7612 7.03065 10.722 6.84986 10.6467C6.66907 10.5714 6.50516 10.4615 6.36761 10.3232C6.23006 10.185 6.12158 10.0211 6.04845 9.84123C5.97532 9.66132 5.93898 9.46887 5.94153 9.27499C5.94714 8.8879 6.10726 8.51867 6.38703 8.24769C6.6668 7.9767 7.04357 7.82592 7.43531 7.82815Z"
                fill="white"
              />
              <path
                d="M22.7754 9.30536C22.772 9.69278 22.6141 10.0632 22.336 10.3363C22.0579 10.6094 21.6821 10.7631 21.29 10.764C20.8972 10.7625 20.5208 10.608 20.2427 10.3338C19.9646 10.0597 19.8072 9.68817 19.8047 9.29998C19.8047 9.10602 19.8436 8.91397 19.9191 8.73495C19.9947 8.55593 20.1054 8.39348 20.2448 8.25698C20.3843 8.12049 20.5497 8.01266 20.7316 7.93974C20.9134 7.86681 21.1081 7.83022 21.3044 7.8321C21.6968 7.83585 22.0717 7.99289 22.3474 8.26893C22.623 8.54497 22.7769 8.91757 22.7754 9.30536Z"
                fill="white"
              />
            </svg>
          </i>

          <span
            onClick={() => setIsWelcomeChatboxOpen(!isWelcomeChatboxOpen)}
            className="chat-text"
          >
            Chat with us
          </span>
        </button>
      )}
      {isWelcomeChatboxOpen && (
        <div className="chatbox welcome-screen">
          <button
            onClick={() => {
              setIsWelcomeChatboxOpen(false);
            }}
            className="closebtn"
          >
            <i className="close">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
              >
                <g clip-path="url(#clip0_113_4751)">
                  <path
                    d="M7.99356 10.0767C7.91526 10.1775 7.87444 10.2437 7.82072 10.297C6.0894 12.03 4.35767 13.7621 2.62427 15.493C2.09075 16.0256 1.41439 16.1451 0.800076 15.8224C-0.0549622 15.3731 -0.264036 14.2343 0.37693 13.5115C0.436903 13.444 0.500625 13.3803 0.564763 13.3166C2.27734 11.604 3.98991 9.89184 5.70332 8.1805C5.75705 8.12678 5.82244 8.08515 5.92281 7.94607C5.84992 7.90485 5.76329 7.87779 5.70624 7.82074C3.96659 6.0865 2.22861 4.35059 0.493128 2.61177C-0.178241 1.93931 -0.160749 0.967049 0.525198 0.368288C1.0787 -0.115134 1.91542 -0.118049 2.471 0.362875C2.54972 0.430746 2.6226 0.505279 2.69632 0.578979C4.40431 2.28616 6.11231 3.99333 7.81905 5.70134C7.87278 5.75506 7.91567 5.8196 7.97731 5.89579C8.06061 5.81627 8.12017 5.76214 8.17723 5.70509C9.91479 3.96835 11.6507 2.23078 13.3895 0.495286C13.9334 -0.04768 14.6539 -0.150527 15.2699 0.217973C16.0637 0.693068 16.2407 1.76901 15.6389 2.47145C15.5715 2.55014 15.4969 2.62384 15.4236 2.69754C13.716 4.40514 12.0084 6.11273 10.2996 7.81908C10.2459 7.87279 10.1809 7.91526 10.1051 7.97605C10.1855 8.06058 10.2401 8.12012 10.2971 8.17717C12.0293 9.90933 13.7606 11.6419 15.4944 13.3724C15.9671 13.8442 16.1262 14.3959 15.8967 15.0267C15.5431 16.0006 14.3162 16.3096 13.5278 15.635C13.4541 15.5722 13.3858 15.5022 13.3175 15.4335C11.6045 13.7213 9.89188 12.0092 8.18014 10.2961C8.126 10.2429 8.08102 10.1808 7.99356 10.0767Z"
                    fill="currentColor"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_113_4751">
                    <rect width="16" height="16" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </i>
          </button>
          <div className="flex brand-logo">
            <a href="#">
              <img
                src={myPlugin.pluginUrl + "build/images/logo-mark.svg"}
                alt="Logo"
              />
            </a>
          </div>
          <h2>Welcome!</h2>
          <div className="chat-box-welcome">
            <div className="flex chat-welcome-cnt">
              <span className="user-icon">
                <img
                  src={myPlugin.pluginUrl + "build/images/logo-mark.svg"}
                  alt="User Avatar"
                />
                <span className="status online"></span>
              </span>
              <div className="user-detail">
                <p className="cht-cnt">
                  Hello there! <br />
                  How can I help you?
                </p>
              </div>
            </div>
            <button onClick={toggleChatbox} className="chat-now">
              Chat Now
            </button>
          </div>
          <div className="flex welcome-footer">
            <a
              className="welcome-footer-link"
              href="https://ccs-technologies.com/"
            >
              <i>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="22"
                  viewBox="0 0 24 22"
                  fill="none"
                >
                  <path
                    d="M21.5906 12.5673V12.8219C21.5906 15.5718 21.5906 18.3218 21.5906 21.0717C21.5906 21.7003 21.2879 22.0004 20.6528 22.0004H3.33566C2.69577 22.0004 2.39262 21.7018 2.39262 21.0764V12.5696C2.17625 12.5696 1.97868 12.5732 1.78072 12.5696C0.416944 12.5402 -0.41891 11.1821 0.207786 9.99373C0.312168 9.79534 0.473734 9.61581 0.640106 9.46024C3.0533 7.21183 5.46824 4.96643 7.88491 2.72404C8.5384 2.11669 9.19095 1.50856 9.84258 0.899642C11.1288 -0.307194 12.8717 -0.295016 14.1563 0.907106C16.5103 3.11021 18.8707 5.30677 21.2375 7.49677C21.9826 8.18976 22.7344 8.87568 23.4643 9.5832C23.9926 10.0939 24.1298 10.7299 23.875 11.4096C23.6091 12.1198 23.0628 12.5095 22.2885 12.5649C22.0649 12.581 21.839 12.5673 21.5906 12.5673ZM7.99289 20.4188V20.1603C7.99289 18.9558 7.98568 17.7513 7.99808 16.5461C8.00052 16.226 8.03766 15.907 8.10886 15.5946C8.58878 13.5235 10.7184 12.2059 12.8309 12.6584C13.7217 12.8457 14.5206 13.3263 15.0952 14.0207C15.6698 14.715 15.9856 15.5813 15.9904 16.4761C15.998 17.7132 15.9904 18.9511 15.9904 20.1878V20.4176H19.9897V20.1764C19.9897 17.4003 19.9897 14.6241 19.9897 11.848C19.9897 11.3278 20.322 11.001 20.8479 10.999C21.2609 10.9969 21.6742 10.9969 22.0877 10.999C22.2033 10.999 22.3437 11.0092 22.3625 10.8714C22.3737 10.7896 22.3153 10.6722 22.2493 10.6109C19.1717 7.74073 16.0914 4.87293 13.0085 2.00748C12.3686 1.41349 11.5959 1.4182 10.9624 2.01376C10.2785 2.65568 9.59235 3.29537 8.90393 3.93284C6.50433 6.16423 4.10554 8.39653 1.70754 10.6298C1.64795 10.6851 1.59635 10.8148 1.62275 10.8753C1.64914 10.9358 1.77632 10.9892 1.86271 10.9931C2.26264 11.0049 2.66257 10.9982 3.06251 10.9986C3.6856 10.9986 3.99315 11.3011 3.99315 11.9148C3.99315 14.6705 3.99315 17.4265 3.99315 20.1827V20.4184L7.99289 20.4188ZM14.381 20.4188C14.385 20.3795 14.391 20.3473 14.391 20.3159C14.391 19.0077 14.3978 17.6991 14.3862 16.3909C14.3814 15.8708 14.1827 15.4088 13.8447 15.0073C13.198 14.2412 12.147 13.9466 11.2311 14.2652C10.2313 14.6129 9.59662 15.4767 9.59142 16.5009C9.58782 17.7439 9.59142 18.9869 9.59142 20.2298V20.4188H14.381Z"
                    fill="currentColor"
                  />
                </svg>
              </i>
              <p>Home</p>
            </a>
            <a
              className="welcome-footer-link"
              href="https://ccs-technologies.com/contact-us/"
            >
              <i>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="26"
                  height="26"
                  viewBox="0 0 26 26"
                  fill="none"
                >
                  <g clipPath="url(#clip0_113_4717)">
                    <path
                      d="M22.7561 25.9993C22.2687 25.5045 21.7812 25.0079 21.2885 24.5151C20.0511 23.2739 18.8114 22.0351 17.5691 20.7985C17.4873 20.7237 17.3814 20.6805 17.2706 20.6766C15.1789 20.6697 13.0865 20.6632 10.9957 20.6766C10.4855 20.6799 9.98017 20.7173 9.49962 20.5019C8.41298 20.0091 7.7935 19.1359 7.52377 18.0035C7.45065 17.6975 7.43358 17.3733 7.43034 17.0568C7.42018 15.9126 7.42669 14.7684 7.42669 13.6243V13.3646L3.28326 17.5306L3.20202 17.4814C3.19795 17.4058 3.19105 17.3302 3.19105 17.2547C3.19105 15.6432 3.18738 14.0314 3.1951 12.4195C3.1951 12.2229 3.14473 12.1583 2.94244 12.1331C1.52433 11.9576 0.282525 10.7443 0.0542305 9.32343C0.0207549 9.11652 0.00364034 8.9073 0.00304664 8.6977C-0.00101555 6.95055 -0.00101555 5.20341 0.00304664 3.45626C0.00304664 1.74974 1.16889 0.340648 2.84657 0.0168157C2.95414 0.00106232 3.06293 -0.00465068 3.17155 -0.000249461C7.18526 -0.000249461 11.1994 -0.00146837 15.2139 -0.00390625C16.2156 -0.00390625 17.0228 0.397125 17.6845 1.11467C18.2837 1.76478 18.5672 2.54815 18.5737 3.43066C18.5802 4.31317 18.581 5.20463 18.5717 6.09161C18.5717 6.28298 18.618 6.34515 18.8174 6.34352C20.0698 6.3354 21.3222 6.33011 22.5746 6.34352C24.2153 6.36059 25.5676 7.46373 25.9218 9.06582C25.9731 9.31086 25.9982 9.56066 25.9965 9.811C26.002 12.276 26.0028 14.7409 25.999 17.2059C26.0032 18.0368 25.7063 18.8411 25.1633 19.47C24.6203 20.0988 23.8679 20.5096 23.0454 20.6263C22.8699 20.6523 22.8098 20.7108 22.8106 20.8932C22.8175 22.5046 22.8142 24.1161 22.8142 25.7283V25.9677L22.7561 25.9993ZM21.228 19.0806C21.6724 19.0806 22.0839 19.0806 22.4958 19.0806C22.5363 19.0829 22.5756 19.0955 22.6099 19.1172C22.9556 19.3232 23.2672 19.2273 23.5442 18.9892C24.1015 18.5085 24.3891 17.8922 24.4078 17.1551C24.42 16.6952 24.4107 16.2344 24.4107 15.7737C24.4107 13.8036 24.4107 11.8332 24.4107 9.8626C24.4082 8.72493 23.6112 7.93018 22.4787 7.92977C18.6332 7.92814 14.7876 7.92936 10.9421 7.93343C10.7125 7.9319 10.4842 7.96913 10.267 8.04354C9.46671 8.33121 9.02637 8.99025 9.02515 9.87601C9.02271 12.2868 9.02271 14.6976 9.02515 17.1084C9.02515 17.2031 9.02881 17.2981 9.03693 17.3928C9.07222 17.8441 9.27735 18.2652 9.61092 18.5711C10.0066 18.9453 10.4867 19.0827 11.0233 19.0819C13.3047 19.0774 15.586 19.0819 17.8669 19.077C17.9432 19.0726 18.0196 19.0851 18.0905 19.1137C18.1615 19.1423 18.2252 19.1862 18.2772 19.2423C19.0323 20.0095 19.796 20.7677 20.5573 21.5283C20.7649 21.7359 20.9749 21.9415 21.2288 22.1926V19.0806H21.228ZM4.77611 13.6673C4.80905 13.6508 4.84068 13.6318 4.87075 13.6104C5.69456 12.7881 6.51688 11.9642 7.33772 11.1388C7.39245 11.073 7.42286 10.9904 7.42384 10.9048C7.43318 10.5464 7.40028 10.1848 7.43562 9.82929C7.47624 9.41525 7.51239 8.98456 7.65457 8.59978C8.17818 7.18256 9.43096 6.34393 10.9449 6.34352C12.8807 6.34352 14.8163 6.34461 16.7518 6.34677C16.9224 6.34677 16.9887 6.31264 16.9866 6.12533C16.9765 5.23144 16.9907 4.33755 16.9789 3.44366C16.9647 2.35596 16.1819 1.57462 15.0997 1.57178C11.2285 1.5669 7.35736 1.5669 3.48637 1.57178C2.40217 1.57178 1.60639 2.3519 1.59827 3.43513C1.58446 5.19582 1.58446 6.95651 1.59827 8.71721C1.60639 9.79556 2.4107 10.572 3.48961 10.581C3.8483 10.5842 4.2074 10.5903 4.56568 10.5777C4.73792 10.5716 4.7822 10.6305 4.78098 10.7967C4.77408 11.6699 4.77813 12.5439 4.77813 13.4162L4.77611 13.6673Z"
                      fill="currentColor"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_113_4717">
                      <rect width="26" height="26" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </i>
              <p>Contact us</p>
            </a>
          </div>
        </div>
      )}
      {isChatboxOpen && (
        <div className="chatbox cmn-cat-box">
          <div className="chatbox-header">
            <div className="user-detail flex">
              <span className="user-img">
                <img
                  src={myPlugin.pluginUrl + "build/images/logo-mark.svg"}
                  alt="User Avatar"
                />
              </span>
              <span className="username">CCS</span>
            </div>

            <div className="chatbox-header-control">
              <button
                onClick={() => {
                  setMessages([]);
                  setIsChatboxOpen(false);
                  setSessionId(uuidv4());
                  setIsWelcomeChatboxOpen(false);
                }}
              >
                <i className="close">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <g clipPath="url(#clip0_113_4751)">
                      <path
                        d="M7.99356 10.0767C7.91526 10.1775 7.87444 10.2437 7.82072 10.297C6.0894 12.03 4.35767 13.7621 2.62427 15.493C2.09075 16.0256 1.41439 16.1451 0.800076 15.8224C-0.0549622 15.3731 -0.264036 14.2343 0.37693 13.5115C0.436903 13.444 0.500625 13.3803 0.564763 13.3166C2.27734 11.604 3.98991 9.89184 5.70332 8.1805C5.75705 8.12678 5.82244 8.08515 5.92281 7.94607C5.84992 7.90485 5.76329 7.87779 5.70624 7.82074C3.96659 6.0865 2.22861 4.35059 0.493128 2.61177C-0.178241 1.93931 -0.160749 0.967049 0.525198 0.368288C1.0787 -0.115134 1.91542 -0.118049 2.471 0.362875C2.54972 0.430746 2.6226 0.505279 2.69632 0.578979C4.40431 2.28616 6.11231 3.99333 7.81905 5.70134C7.87278 5.75506 7.91567 5.8196 7.97731 5.89579C8.06061 5.81627 8.12017 5.76214 8.17723 5.70509C9.91479 3.96835 11.6507 2.23078 13.3895 0.495286C13.9334 -0.04768 14.6539 -0.150527 15.2699 0.217973C16.0637 0.693068 16.2407 1.76901 15.6389 2.47145C15.5715 2.55014 15.4969 2.62384 15.4236 2.69754C13.716 4.40514 12.0084 6.11273 10.2996 7.81908C10.2459 7.87279 10.1809 7.91526 10.1051 7.97605C10.1855 8.06058 10.2401 8.12012 10.2971 8.17717C12.0293 9.90933 13.7606 11.6419 15.4944 13.3724C15.9671 13.8442 16.1262 14.3959 15.8967 15.0267C15.5431 16.0006 14.3162 16.3096 13.5278 15.635C13.4541 15.5722 13.3858 15.5022 13.3175 15.4335C11.6045 13.7213 9.89188 12.0092 8.18014 10.2961C8.126 10.2429 8.08102 10.1808 7.99356 10.0767Z"
                        fill="currentColor"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_113_4751">
                        <rect width="16" height="16" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </i>
              </button>
            </div>
          </div>
          <div className="chatbox-body customized-scrollbar">
            <div className="flex chat-cnt-wrap">
              <div className="chatbox-messages">
                <div className="message-wrap">
                  {!loader &&
                    messages.map((message, index) => (
                      <>
                        <div
                          key={index}
                          className={
                            message.sender === "bot"
                              ? "message-container bot"
                              : "message-container user"
                          }
                        >
                          {message.sender === "bot" && (
                            <div className="user-detil ">
                              <span className="user-imag">
                                <img
                                  src={
                                    myPlugin.pluginUrl +
                                    "build/images/logo-mark.svg"
                                  }
                                  alt="User Avatar"
                                />
                              </span>
                              <span className="user-name">CCS</span>
                            </div>
                          )}
                          <div
                            className={
                              message.sender === "bot" ? "message" : "reply-msg"
                            }
                          >
                            {message.text}
                          </div>
                        </div>
                      </>
                    ))}
                  {loader && (
                    <div>
                      <div className="user-detil ">
                        <span className="user-imag">
                          <img
                            src={
                              myPlugin.pluginUrl + "build/images/logo-mark.svg"
                            }
                            alt="User Avatar"
                          />
                        </span>
                        <span className="user-name">CCS</span>
                      </div>
                      <div className="message">
                        <div class="loading">
                          <span class="loading__dot"></span>
                          <span class="loading__dot"></span>
                          <span class="loading__dot"></span>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                <div ref={messagesEndRef} />
              </div>
            </div>
          </div>
          {charLimitExceeded && (
            <div className="warning">Please shorten your message.</div>
          )}
          <div className="chatbox-input flex">
            <input
              ref={inputRef}
              type="text"
              value={inputText}
              onChange={(e) => handleInputChange(e)}
              onKeyDown={handleKeyPress}
              placeholder="Write a message..."
            />

            <div className="chat-cntrls flex">
              {/* <button className="smiley">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <g clipPath="url(#clip0_113_4743)">
                    <path
                      d="M11.9731 23.9997C5.20613 23.9404 -0.0313654 18.494 0.0001414 11.9545C0.00335309 10.3787 0.317545 8.81892 0.924721 7.36466C1.5319 5.9104 2.42012 4.59021 3.5385 3.47971C4.65689 2.36921 5.98345 1.49024 7.44219 0.893155C8.90093 0.296068 10.4632 -0.00740033 12.0394 0.000137035C13.6154 0.00227531 15.1755 0.315313 16.6302 0.921309C18.085 1.52731 19.4058 2.41435 20.5171 3.5316C21.6283 4.64886 22.5081 5.97436 23.106 7.43215C23.7039 8.88994 24.0082 10.4514 24.0014 12.0269C23.9735 18.7329 18.5576 23.9944 11.9731 23.9997ZM12.0075 2.17928C6.59365 2.17396 2.19457 6.55638 2.18025 11.9738C2.16593 17.3911 6.55642 21.7993 11.983 21.8132C17.3984 21.8288 21.8094 17.432 21.82 12.0077C21.8307 6.58338 17.4328 2.185 12.0075 2.17764V2.17928Z"
                      fill="currentColor"
                    />
                    <path
                      d="M12.1307 17.4558C10.2571 17.4301 8.77217 16.7653 7.49471 15.6052C7.24344 15.3752 7.00944 15.127 6.79461 14.8627C6.40179 14.3825 6.47954 13.7173 6.95337 13.3299C7.41615 12.9507 8.08925 13.0276 8.49024 13.4989C9.20344 14.3366 10.0725 14.9306 11.1585 15.1761C12.285 15.4276 13.3206 15.1785 14.2846 14.5755C14.7478 14.2853 15.1621 13.9236 15.5122 13.5038C15.914 13.0239 16.5879 12.9507 17.0478 13.3291C17.5347 13.73 17.6051 14.4054 17.1869 14.895C15.8252 16.4859 14.1242 17.3982 12.1307 17.4558Z"
                      fill="currentColor"
                    />
                    <path
                      d="M7.64485 8.73367C7.64133 8.59027 7.66673 8.44762 7.71953 8.31424C7.77233 8.18086 7.85145 8.05947 7.95219 7.95731C8.05292 7.85516 8.17319 7.77433 8.30584 7.71964C8.43849 7.66495 8.58079 7.63752 8.72427 7.63899C8.86772 7.63551 9.01043 7.66067 9.14403 7.71302C9.27763 7.76537 9.39945 7.84384 9.50233 7.94384C9.60522 8.04384 9.68711 8.16337 9.74321 8.29541C9.79931 8.42745 9.8285 8.56935 9.82905 8.71281C9.83101 8.85624 9.80441 8.99862 9.75082 9.13168C9.69723 9.26474 9.61771 9.38582 9.51689 9.48788C9.41606 9.58993 9.29594 9.67092 9.16352 9.72614C9.0311 9.78137 8.88902 9.80971 8.74555 9.80954C8.60207 9.8132 8.45932 9.78806 8.32573 9.7356C8.19214 9.68314 8.07044 9.60443 7.96781 9.50412C7.86519 9.40381 7.78373 9.28394 7.72826 9.15161C7.67279 9.01927 7.64442 8.87716 7.64485 8.73367Z"
                      fill="currentColor"
                    />
                    <path
                      d="M15.2784 7.64079C15.4219 7.63834 15.5646 7.66456 15.6978 7.71794C15.8311 7.77131 15.9524 7.85076 16.0546 7.95161C16.1568 8.05247 16.2378 8.1727 16.2929 8.30527C16.348 8.43783 16.376 8.58006 16.3754 8.72361C16.3763 8.86703 16.3486 9.00919 16.2941 9.14183C16.2395 9.27448 16.1591 9.39496 16.0576 9.49628C15.956 9.5976 15.8354 9.67774 15.7026 9.73204C15.5698 9.78633 15.4276 9.8137 15.2841 9.81256C15.1407 9.81514 14.9981 9.78893 14.865 9.7355C14.7318 9.68206 14.6108 9.60248 14.5089 9.50145C14.407 9.40043 14.3265 9.28001 14.272 9.14732C14.2175 9.01463 14.1902 8.87236 14.1916 8.72892C14.1889 8.58542 14.2151 8.44284 14.2688 8.3097C14.3224 8.17656 14.4023 8.0556 14.5038 7.95403C14.6052 7.85246 14.7261 7.77238 14.8592 7.71856C14.9923 7.66474 15.1348 7.63829 15.2784 7.64079Z"
                      fill="currentColor"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_113_4743">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </button>
              <button className="add">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <g clipPath="url(#clip0_113_4740)">
                    <path
                      d="M12.0024 7.04582e-07C18.6183 0.0026257 24.0026 5.38688 24.0004 12C23.9981 18.6131 18.6153 24 12.0002 24C5.37871 24 -0.00487177 18.6068 3.30834e-06 11.9809C0.00487838 5.38463 5.40121 -0.0022493 12.0024 7.04582e-07ZM21.9971 12.0083C22.0016 6.48938 17.551 2.03325 12.0137 2.00738C6.5131 1.98375 2.02241 6.46125 2.00816 11.985C1.99391 17.5088 6.46735 21.9874 11.9998 21.9975C17.5064 22.0076 21.9926 17.5245 21.9971 12.0083Z"
                      fill="currentColor"
                    />
                    <path
                      d="M8.8757 11.0054C9.50683 11.0054 10.1383 10.9982 10.7691 11.0095C10.963 11.0129 11.011 10.9484 11.0102 10.7627C11.003 9.51274 11.003 8.26274 11.0102 7.01274C11.0132 6.42024 11.4602 5.98824 12.0329 6.00024C12.5331 6.01187 12.9663 6.40299 12.9869 6.90362C13.0101 7.47137 12.9989 8.04062 12.9996 8.60949C12.9996 9.33437 13.0049 10.0592 12.9963 10.7845C12.994 10.9604 13.0533 11.0076 13.2213 11.0069C14.4713 11.0014 15.7213 11.0014 16.9713 11.0069C17.5867 11.0095 18.024 11.4606 18.0003 12.0497C17.9808 12.5316 17.5968 12.9527 17.1146 12.9839C16.7351 13.0079 16.3529 12.9966 15.9716 12.997C15.0592 12.997 14.1468 13.003 13.234 12.9932C13.039 12.991 12.994 13.0551 12.9951 13.24C13.0023 14.4647 13 15.6899 12.9981 16.915C12.9981 17.4445 12.7304 17.8296 12.2826 17.9586C12.1373 18.0026 11.9837 18.0124 11.834 17.9872C11.6843 17.962 11.5424 17.9025 11.4194 17.8133C11.2965 17.7242 11.1959 17.6078 11.1254 17.4733C11.0549 17.3388 11.0165 17.1898 11.0132 17.038C10.9982 16.4196 11.008 15.8005 11.0076 15.1817C11.0076 14.5319 11.0001 13.882 11.0121 13.2317C11.0159 13.0349 10.9469 12.9929 10.7639 12.9936C9.53283 13.0009 8.30169 13.0017 7.07042 12.9962C6.53753 12.9962 6.1569 12.7135 6.03615 12.2462C5.87865 11.6369 6.31666 11.0279 6.94629 11.0121C7.58943 10.9956 8.23369 11.0084 8.8772 11.0084L8.8757 11.0054Z"
                      fill="currentColor"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_113_4740">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </button> */}
              <button
                onClick={sendMessage}
                className={`${charLimitExceeded ? "send btn-disable" : "send"}`}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="22"
                  viewBox="0 0 25 22"
                  fill="none"
                >
                  <g clipPath="url(#clip0_113_4738)">
                    <path
                      d="M0.000582093 18.0264C-0.0111457 17.486 0.154918 16.8908 0.446707 16.3244C1.32833 14.6129 2.20964 12.9014 3.09063 11.1899C3.12682 11.1288 3.14563 11.0594 3.14513 10.9889C3.14464 10.9184 3.12486 10.8493 3.08782 10.7887C2.20682 9.08542 1.33521 7.37711 0.45562 5.67336C-0.767828 3.30371 0.643266 0.530605 3.32097 0.0595972C4.3427 -0.120226 5.2767 0.136729 6.18256 0.607281C8.76597 1.94865 11.3616 3.26857 13.953 4.59579C16.717 6.01094 19.4816 7.42579 22.2469 8.84034C22.9102 9.18036 23.5712 9.52494 24.2369 9.85948C24.713 10.0996 25.001 10.4528 25.0015 10.9927C25.002 11.5327 24.713 11.8859 24.2392 12.1283C19.9609 14.3172 15.6834 16.5079 11.4066 18.7005C9.52687 19.6626 7.6537 20.6384 5.76317 21.579C3.12206 22.8875 0.004335 21.0103 0.000582093 18.0264ZM21.0638 10.9978C20.97 10.9416 20.923 10.9119 20.8761 10.8873C18.9828 9.9176 17.0893 8.9482 15.1956 7.9791L7.52563 4.05084C6.59256 3.57299 5.66184 3.09239 4.72596 2.61865C4.18132 2.34481 3.63809 2.35302 3.13098 2.70399C2.48594 3.15127 2.33348 3.88745 2.71675 4.63321C3.56459 6.28478 4.41213 7.93651 5.25934 9.58838C5.33159 9.72987 5.41884 9.78646 5.5835 9.78509C6.47482 9.77824 7.36613 9.78098 8.25745 9.78144C9.26557 9.78144 10.2746 9.7714 11.2823 9.78829C12.1333 9.80289 12.6896 10.5733 12.4466 11.3629C12.2867 11.8804 11.8049 12.204 11.1669 12.2054C9.40068 12.209 7.634 12.2214 5.86591 12.1963C5.47889 12.1908 5.29453 12.3049 5.12799 12.639C4.3305 14.2387 3.49923 15.8219 2.6886 17.4152C2.36773 18.0455 2.48548 18.7078 2.97242 19.1546C3.45936 19.6014 4.14192 19.6676 4.77569 19.3413C6.33596 18.5383 7.89748 17.7381 9.46026 16.9406L19.9098 11.5924C20.2794 11.4008 20.6496 11.2091 21.0619 10.9959L21.0638 10.9978Z"
                      fill="currentColor"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_113_4738">
                      <rect width="25" height="22" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Chatbot;
